import request from '@/scripts/request';
import { exportApis } from '@/scripts/utils/devUtils';

export const commonApis = {
  getSystemDate() {
    return request('/api/v1/system/time').then((res) => res.data.time);
  },
  getFileSDKToken() {
    return request('/api/v1/file/token/generate', { method: 'POST' }).then(
      (res) => res.data.token
    );
  },
};

exportApis({ commonApis });
